<script>
  import JsonApiCollectionStore from "~/lib/store/JsonApiCollectionStore"

  export let users = {data:[]}

  const hideIfMoreRowsThan = 4
  const showRows = 3

  $: collection = new JsonApiCollectionStore(users);
  $: defaultShowAll = $collection.size <= hideIfMoreRowsThan
  
  let showAll = false

  $: hideRows = (defaultShowAll || showAll) ? false : $collection.size - showRows

  const tag = user=>user.is_current_user ? "You" : user.status == "Owner" ? "Owner" : null
</script>

<table class="table table-striped">
  <thead>
    <tr>
      <th colspan="3">Account contact</th>
    </tr>
  </thead>
  <tbody>
    {#each [...$collection].slice(0, hideRows ? showRows : undefined) as user (user.id)}
      {@const userTag = tag(user)}
      <tr>
        <td>{user.full_name}</td>
        {#if userTag}
          <td>{user.email}</td>
          <td>{userTag}</td>
        {:else}
          <td colspan="2">{user.email}</td>
        {/if}
      </tr>
    {/each}
    {#if hideRows}
      <tr><td colspan="3"><a href="#" on:click|preventDefault={()=>showAll = true}>Show {hideRows} more</a></td></tr>
    {/if}
  </tbody>
</table>

<style>
  table {
    margin-bottom: 2.5rem;
  }
  th {
    border-top: none;
    padding: 0 0 0.5rem;
  }
</style>